import React from "react";
import TreileScanningPage from "./TreileScanningPage";

function App() {
  return <TreileScanningPage />;
}

export default App;

